module.exports = __webpack_public_path__ + "static/img/1.11faa0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/1.jpg
// module id = EAut
// module chunks = 16